class NewsletterPopup extends ModalDialog {
  constructor() {
    super();
  }

  init() {
    this.delay = this.dataset.delay * 1000;
    this.closed = getCookie("newsletter-closed");
    this.subscribed = getCookie("newsletter-subscribed");
    this.form = this.querySelector(".js-form");
    this.formWrapper = this.querySelector(".js-newsletter-form-wrapper");
    this.successBlock = this.querySelector(".js-newsletter-success");
    this.heading = this.querySelector(
      ".newsletter-popup__content > .section__heading"
    );
    this.subheading = this.querySelector(".newsletter-popup__subheading");
    this.entry = this.querySelector(".newsletter-popup__entry");
    this.closeWrapper = this.querySelector(".newsletter-popup__close-wrapper");
    this.ageVerificationPopup = document.querySelector("age-verification-popup");

    this.sectionId = this.id ? this.id.replace("NewsletterModal-", "") : null;

    this.badge = this.sectionId
      ? document.querySelector(`[data-newsletter-badge="${this.sectionId}"]`)
      : null;
  }

  attachEventListeners() {
    this.buttonClose = this.querySelector(".js-button-close");

    if (this.buttonClose) {
      this.buttonClose.addEventListener(
        "click",
        this.closeNewsletter.bind(this)
      );
    }

    if (this.form) {
      this.form.addEventListener("submit", this.onSubscribe.bind(this));
    }

    if (this.badge) {
      this.badge.addEventListener("click", this.reopenFromBadge.bind(this));
    }
  }

  connectedCallback() {
    this.init();                  // ✅ la page est prête, on peut chercher les éléments
    this.attachEventListeners();  // ✅ idem

    if (Shopify.designMode) {
      if (this.dataset.openInDesignMode === "true") {
        this.show();
      }
      return;
    }

    this.handlePopupVisibility();
  }

  handlePopupVisibility() {
    if (this.subscribed === "true") return;

    if (this.closed === "true") {
      this.showBadge();
      return;
    }

    if (getCookie("age-verified") !== "true" && this.ageVerificationPopup) {
      this.handleAgeVerificationPopup();
    } else {
      this.showPopupWithDelay();
    }
  }

  handleAgeVerificationPopup() {
    let prevClassState = this.classList.contains("newsletter-popup-is-hidden");

    const observer = new MutationObserver((mutations) => {
      const mutation = mutations[0];
      if (mutation.attributeName !== "class") return;

      const currentClassState =
        mutation.target.classList.contains("newsletter-popup-is-hidden");

      if (prevClassState !== currentClassState) {
        prevClassState = currentClassState;
        if (!currentClassState) {
          this.showPopupWithDelay();
        }
      }
    });

    observer.observe(this, { attributes: true });
  }

  showPopupWithDelay() {
    setTimeout(() => {
      if (this.closed !== "true" && this.subscribed !== "true") {
        this.hideBadge();
        this.show();
      }
    }, this.delay);
  }

  hide() {
    if (this.subscribed !== "true") {
      setCookie("newsletter-closed", "true");
      this.showBadge();
    }
    super.hide();
  }

  closeNewsletter() {
    this.hide();
  }

  onSubscribe() {
    setCookie("newsletter-subscribed", "true");
    this.hideBadge();
    super.hide();
  }

  showBadge() {
    if (this.badge) {
      this.badge.classList.add("is-visible");
    }
  }

  hideBadge() {
    if (this.badge) {
      this.badge.classList.remove("is-visible");
    }
  }

  reopenFromBadge() {
    this.hideBadge();
    this.show();
  }
}

customElements.define("newsletter-popup", NewsletterPopup);